var map = {
	"./Onboarding/Bigship_logo.svg": 53953,
	"./Onboarding/Cloud.svg": 39554,
	"./Onboarding/CopyIcon.svg": 551,
	"./Onboarding/DelhiveryLogo.svg": 63266,
	"./Onboarding/FileXls.svg": 44436,
	"./Onboarding/Footer.svg": 18182,
	"./Onboarding/GodashLogo.svg": 93424,
	"./Onboarding/IconText.svg": 17101,
	"./Onboarding/ParcelImg.svg": 56613,
	"./Onboarding/Pickup_Instruction.svg": 30486,
	"./Onboarding/Refund_Credited_Policy.svg": 99001,
	"./Onboarding/Shipnexa_logo.svg": 34187,
	"./Onboarding/Stcourier_Icon.svg": 41477,
	"./Onboarding/Stcourier_logo.svg": 49191,
	"./Onboarding/Upload_Icon.svg": 81436,
	"./Onboarding/Zippyy-Logo-White.svg": 30434,
	"./Onboarding/Zippyy-Logo.svg": 72166,
	"./Onboarding/ZippyyBanner.svg": 62464,
	"./Onboarding/Zippyy_logo_Orange.svg": 94545,
	"./Onboarding/exportIcon.svg": 54838,
	"./Onboarding/order_management.svg": 27817,
	"./Onboarding/parcelPickup.svg": 84244,
	"./Onboarding/rateCard.svg": 10419,
	"./Orders/RTOReceivedImg.svg": 14470,
	"./Orders/RateVector1.svg": 44177,
	"./Orders/Vector.svg": 44762,
	"./Orders/blitz.svg": 59256,
	"./Orders/jpegLogo.svg": 12640,
	"./Orders/no_orders.svg": 50614,
	"./Orders/no_rates.svg": 84130,
	"./Orders/package.svg": 11149,
	"./bigshipIcons/bigship_AdminPanel.svg": 94326,
	"./bigshipIcons/bigship_Billing.svg": 12068,
	"./bigshipIcons/bigship_FinalCharges.svg": 64964,
	"./bigshipIcons/bigship_Invoicing.svg": 1953,
	"./bigshipIcons/bigship_ShipmentDispute.svg": 81219,
	"./bigshipIcons/bigship_bulkAction.svg": 20413,
	"./bigshipIcons/bigship_configuration_icon.svg": 45909,
	"./bigshipIcons/bigship_integration.svg": 79727,
	"./bigshipIcons/bigship_rateCard.svg": 35491,
	"./bigshipIcons/bigship_vasControl.svg": 37406,
	"./bigshipIcons/bigship_weightDispute.svg": 11597,
	"./carriers/dhl.svg": 7001,
	"./favicons/Stcourier_favicon.svg": 97914,
	"./favicons/bigship_favicon.svg": 29496,
	"./order/MisB2B.svg": 63065,
	"./order/humbleicons.svg": 95805,
	"./searchOptionIcons/TRACKING_CODE.svg": 7294,
	"./shipnexaIcons/shipnexa_AdminPanel.svg": 43620,
	"./shipnexaIcons/shipnexa_Billing.svg": 34890,
	"./shipnexaIcons/shipnexa_FinalCharges.svg": 35306,
	"./shipnexaIcons/shipnexa_Invoicing.svg": 79643,
	"./shipnexaIcons/shipnexa_ShipmentDispute.svg": 55433,
	"./shipnexaIcons/shipnexa_bulkAction.svg": 57943,
	"./shipnexaIcons/shipnexa_configuration_icon.svg": 56067,
	"./shipnexaIcons/shipnexa_integration.svg": 72421,
	"./shipnexaIcons/shipnexa_rateCard.svg": 85301,
	"./shipnexaIcons/shipnexa_vasControl.svg": 79264,
	"./shipnexaIcons/shipnexa_weightDispute.svg": 47163,
	"./zippyyIcons/zippyy_AdminPanel.svg": 82984,
	"./zippyyIcons/zippyy_Billing.svg": 23414,
	"./zippyyIcons/zippyy_FinalCharges.svg": 14662,
	"./zippyyIcons/zippyy_Invoicing.svg": 43423,
	"./zippyyIcons/zippyy_ShipmentDispute.svg": 2869,
	"./zippyyIcons/zippyy_bulkAction.svg": 11139,
	"./zippyyIcons/zippyy_configuration_icon.svg": 19359,
	"./zippyyIcons/zippyy_integration.svg": 77433,
	"./zippyyIcons/zippyy_rateCard.svg": 97329,
	"./zippyyIcons/zippyy_vasControl.svg": 42036,
	"./zippyyIcons/zippyy_weightDispute.svg": 61303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;